import { smrApi } from '@/utils/axios-config'

const apiBase = 'shortlink';

export default {
    shortenURL(url) {
        const numWeeks = 2;
        const validDate = new Date();
        validDate.setDate(validDate.getDate() + numWeeks * 7);
        const timezoneOffset = validDate.getTimezoneOffset()
        const timezoneOffsetHours = timezoneOffset / 60

        let domain = '120.at'
        if(window.location.origin.indexOf('webint.oeamtc.at') >= 0 || window.location.origin.indexOf('beta.oeamtc.at') >= 0 || window.location.origin.indexOf('localhost') >= 0) {
            domain = ''
        }
                
        // validUntil format needs to be e.g. 2017-01-21T00:00:00+02:00
        const params = {
            longUrl: url,
            validUntil: validDate.toISOString().slice(0, 19) + `${timezoneOffset < 0 ? '+' : '-'}${timezoneOffsetHours < 10 ? '0' : ''}${timezoneOffsetHours < 0 ? timezoneOffsetHours * -1 : timezoneOffsetHours}:00`,
            tags: [
              'RP_usergenerated'
            ],
            domain: domain,
        }
        return smrApi.post(`${apiBase}/rest/v3/short-urls`, params);
    },
}